import { render, staticRenderFns } from "./ReviewTaskList.vue?vue&type=template&id=62ebaa08&scoped=true"
import script from "./ReviewTaskList.vue?vue&type=script&lang=js"
export * from "./ReviewTaskList.vue?vue&type=script&lang=js"
import style0 from "./ReviewTaskList.vue?vue&type=style&index=0&id=62ebaa08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ebaa08",
  null
  
)

export default component.exports